export const STORAGE_KEYS = {
    GUEST_NAME: 'GUEST_NAME',
    GUEST_DETAILS: 'GUEST_DETAILS',
    GUEST_TOKEN: 'GUEST_TOKEN',
}

export const getStorage = (key: string) => {
    return localStorage.getItem(key);
}

export const setStorage = (key: string, value: any) => {
    return localStorage.setItem(key, (typeof value === 'object' ? JSON.stringify(value) : value));
}